import SetAmountInvestorPackage from './SetAmountInvestorPackage';

export default SetAmountInvestorPackage;
